import React from "react";
import { LoginSuccessContextProvider } from "./LoginSuccessPageView";
import { LoginSuccessPage } from "./views/LoginSuccessPage";

export const LoginSuccess = () => {
  return (
    <LoginSuccessContextProvider>
      <LoginSuccessPage />
    </LoginSuccessContextProvider>
  );
};
